// Agent-specific English strings stay split from the oversized source locale.
export const agentChip = {
  menuLabel: "Agent menu",
  agents: "Agents",
  newConversation: "New conversation",
  allAgents: "All agents",
  showAllAgents: "Show all agents",
  showOneAgent: "Show one agent",
  workspaceMenuLabel: "Workspace menu",
  switchAgent: "Switch agent",
  working: "Working…",
  ready: "Ready to chat",
  whatCanAgentDo: "What can {name} do?",
  help: "Help",
  getHelp: "Get help",
  getApps: "Get the apps",
  discord: "Discord community",
  viewChangelog: "View changelog",
  agentSettings: "Agent settings",
};

export const agentScope = {
  label: "Agent",
  allAgents: "All agents",
};

export const pinning = {
  pinToSwitcher: "Pin to switcher",
  unpinFromSwitcher: "Unpin from switcher",
};

export const identity = {
  title: "Identity",
  subtitle: "Name, emoji, and avatar shown in chats and the sidebar.",
  name: "Display name",
  namePlaceholder: "Agent name",
  emoji: "Emoji",
  chooseImage: "Choose image…",
  replaceImage: "Replace image…",
  imageUnusable: "That image can't be used. Pick an image file up to 2 MB.",
  fileHint: "Saving mirrors identity fields to IDENTITY.md; configured values take precedence.",
};
